import { FormattedMessage } from 'react-intl';
import { useMemo } from 'react';

import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import { Text, TextType } from 'ui-components/components/text';

import { isCentimeters } from '../../../../../../services/unit-services/dimensions/dimension-type-service';

import { messages } from '../../messages';

const WidthCell = ({ value }) => {
  const limitedValue = parseFloat(value.toFixed(2));
  return <Text textType={TextType.Paragraph} value={limitedValue} />;
};

const HeaderCell = ({ sellerDefaultDimensionsUnit }) => {
  const unitMessage = useMemo(
    () => (isCentimeters(sellerDefaultDimensionsUnit) ? messages.cm : messages.in),
    [sellerDefaultDimensionsUnit],
  );

  return <FormattedMessage {...messages.widthColumnHeader} values={{ unit: <FormattedMessage {...unitMessage} /> }} />;
};

export const createWidthColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'dimensions.width',
  Header: HeaderCell,
  Cell: WidthCell,
  width: 1,
  minWidth: 100,
});
